<template>
  <div class="query-form">
    <p style="font-size:14px;margin-bottom:20px">买手店：{{name}}</p>

    <el-form label-position="right" label-width="60px">
      <el-row :gutter="20">
        <el-col :xs="24" :sm="24" :md="24" :lg="20" :xl="20">
          <el-row :gutter="10">
            <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
              <el-form-item label="类目：" prop="categoryType">
                <el-select v-model="form.categoryType" clearable placeholder="请选择" :style="{width: '100%'}">
                  <el-option v-for="(item, index) in categoryList" :key="index" :label="item.label" :value="item.value" :disabled="item.disabled"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
              <el-form-item label="季节：" prop="seasonCodes">
                <el-select v-model="form.seasonCodes" multiple collapse-tags clearable placeholder="请选择" :style="{width: '100%'}">
                  <el-option v-for="(item, index) in gatherSeasonList" :key="index" :label="item.label" :value="item.value" :disabled="item.disabled"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6" v-if='isCo'>
              <el-form-item label="是否CO：" prop="coFlag" label-width="80px">
                <el-select v-model="form.coFlag" clearable placeholder="请选择" :style="{width: '100%'}">
                  <el-option v-for="(item, index) in coList" :key="index" :label="item.label" :value="item.value" :disabled="item.disabled"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
              <el-form-item label="状态：" prop="status">
                <el-select v-model="form.status" clearable placeholder="请选择" :style="{width: '100%'}">
                  <el-option v-for="(item, index) in statusList" :key="index" :label="item.label" :value="item.value" :disabled="item.disabled"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="4" :xl="4">
          <el-button type="primary" size="small" @click.stop="submit">查询</el-button>
          <el-button size="small" @click.stop="reset">重置</el-button>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
export default {
  data() {
    return {
      name: '',
      isCo: false,
      optionProps: {
        expandTrigger: "hover",
        emitPath: false,
        checkStrictly: false,
        multiple: true
      },
      categoryList: [{ label: 'Adult', value: 1 }, { label: 'Kids', value: 2 }],
      statusList: [{ label: '待生效', value: 1 }, { label: '已生效', value: 2 }],
      coList: [{ label: 'CO', value: 1 }, { label: '非CO', value: 0 }],
      form: {
        seasonCodes: [],
        categoryType: null,
        coFlag: null,
        status: 2
      }
    };
  },
  props: ['seasonList', 'coSeasonList'],
  created() {
    const { name, co } = this.$route.query;
    this.name = name;
    this.isCo = co == 'false' ? false : true;
  },
  computed: {
    gatherSeasonList() {
      return this.seasonList;
    }
  },
  methods: {
    submit() {
      if (!this.isCo) {
        delete this.form.coFlag;
      }
      this.$emit("query", this.form);
    },
    reset() {
      this.form.seasonCodes = [];
      this.form.categoryType = null;
      this.form.coFlag = null;
      this.form.status = 2;
      this.submit();
    },
    emitQuery() {
      this.submit()
    },
  }
};
</script>
<style lang="less">
.shuoming {
  margin: 20px 0px 0px 20px;
  font-size: 14px;
  padding-left: 20px;
  line-height: 37px;
  color: #0072c6;
  height: 37px;
  background-color: rgb(230, 247, 255);
  border: 1px solid rgb(186, 231, 255);
}
.span {
  color: rgba(24, 144, 255, 1);
}
</style>
